import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CircularProgress,
  Button,
  Switch,
  Typography,
} from "@material-ui/core";

import TextField from "@material-ui/core/TextField";
import {
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  pokemonContainer: {
    padding: "20px 50px 20px 50px",
  },
  pokemonImg: {
    margin: "auto",
  },
  inputContainer: {
    display: "flex",
  },
  searchIcon: {
    alignSelf: "flex-end",
  },
  appBar: {
    background: "#00203fff",
  },
}));


const Pokedex = (props) => {

  console.log("Re render");

  const { history } = props;
  const classes = useStyles();
  const [pokemonData, setPokemonData] = useState({});
  const [filter, setFilter] = useState("");

  const HandleChange = (e) => {
    setFilter(e.target.value);
  };

  useEffect(() => {
    axios
      .get(`https://pokeapi.co/api/v2/pokemon?limit=807`)
      .then((response) => {
        const { data } = response;
        const { results, next } = data;
        console.log(next);

        const newPokemonData = {};
        results.forEach((pokemon, index) => {
          newPokemonData[index + 1] = {
            id: index + 1,
            name: pokemon.name,
            sprite: `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${
              index + 1
            }.png`,
          };
        });
        setPokemonData(newPokemonData);
      });
  }, []);

  const PokemonCard = (pokemonId) => {
    const { id, name } = pokemonData[`${pokemonId}`];
    const sprite = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${id}.png`;
    return (
      <Grid item xs={12} sm={6} md={4} lg={3} key={pokemonId}>
        <Card
          raised
          variant="elevation"
          onClick={() => history.push(`/${pokemonId}`)}
        >
          <CardMedia
            className={classes.pokemonImg}
            image={sprite}
            style={{ height: "130px", width: "130px" }}
          />
          <CardContent
            style={{ textAlign: "center", textTransform: "capitalize" }}
          >
            {id}. {name}
          </CardContent>
        </Card>
      </Grid>
    );
  };

  return (
    <>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar style={{display:'flex'}}>
          <div className={classes.inputContainer}>
            <SearchIcon className={classes.searchIcon} />
            <TextField
              id="standard-basic"
              label="Pokemon"
              variant="outlined"
              size='small'
              color="secondary"
              style={{color:'yellow', background:'rgba(255,255,255,0.3)', outline:'none', border:'none'}}
              onChange={HandleChange}
            />
          </div>
          <Typography className='pokemon-heading' variant='h4' component='h4' color='default' style={{position:'absolute', right:'3%'}}>Pokemons</Typography>
        </Toolbar>
      </AppBar>
      {pokemonData ? (<>
        
        <Grid container spacing={2} className={classes.pokemonContainer}>
          {Object.keys(pokemonData).map(
            (pokemonId) =>
              pokemonData[pokemonId].name.includes(filter.toLowerCase()) &&
              PokemonCard(pokemonId)
              
          )}
        </Grid>
        </>
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default Pokedex;
